export enum ENV {
    DEMO = 'DEMO',
    DEV = 'DEV',
    LOCAL = 'LOCAL',
    PRELIVE = 'PRELIVE',
    PROD = 'PROD',
    WARDYNSKI = 'WARDYNSKI',
    TEST = 'TEST',
}
